import ModelUtil from '@leverege/model-util';
import ResponsiveModel from "../../responsive/ResponsiveModel.js";
const TYPE = 'molten.dataViewers.aggregations.AggregationsViewModel';
function create(model = null, excludes = null) {
  return {
    ...ResponsiveModel.create(model),
    type: TYPE,
    options: {
      aggregation: null,
      includeFilters: false,
      excludes
    },
    allowExpandedView: null
  };
}
export default {
  ...ResponsiveModel,
  TYPE,
  create,
  ...ModelUtil.createAllValue('options/aggregation', 'aggregation', 'Aggregation'),
  ...ModelUtil.createAllValue('allowExpandedView', 'AllowExpandedView')
};